import script from "./RenderCustom.vue?vue&type=script&setup=true&lang=js"
export * from "./RenderCustom.vue?vue&type=script&setup=true&lang=js"

import "./RenderCustom.vue?vue&type=style&index=0&id=75dd3e13&lang=css"

const __exports__ = script;

export default __exports__